module.exports = __webpack_public_path__ + "static/img/mel-1.7501e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/students/mel-1.png
// module id = o2YM
// module chunks = 1